<!-- src/components/ImageGrid.vue -->
<template>
    <div class="image-grid">
      <!-- <a v-for="(image, index) in images" :key="index" :href="image.link" class="image-link">
        <div class="image" @mouseover="hovered = true" @mouseleave="hovered = false">
          <img :src="image.src" :alt="'Image ' + (index + 1)" class="image" />
          <div v-if="hovered" class="hover-text">Click to explore</div>
        </div>
      </a> -->
      <div>
        <h1 class="frontpage-h1"> <span>人类子宫腺肌病转录组学数据库平台 </span>
          <br>
           <span> Human Adenomyosis Transcriptomics Database</span> </h1>
           <div class="article-title">
           <h2 class="article-name">
            <a
            href="http://doi.org/10.1002/advs.202411752"
            target="_blank" 
            rel="noopener noreferrer">
            Article: From Invaginating Site to Deep Lesion: Spatial Transcriptomics Unravels Ectopic Endometrial Penetration Features in Adenomyosis</a>
  
          </h2></div>
    </div>
    <div class="frontpage-container">
      <div class="left">
        <img :src="require('../assets/frontpage.png')" class="image_front" />
      </div>
      <div class="right">
       <h2 class="frontpage-entrance"><a href="/page1"><span>Spatial Transcriptomics (proliferative)</span></a></h2>
       <h2 class="frontpage-entrance"><a href="/page2"><span>Single-cell Transcriptomics</span></a></h2>
       <h2 class="frontpage-entrance"><a href="/page3"><span>Bulk Transcriptomics of Endometrium (proliferative)</span></a></h2>
       <h2 class="frontpage-entrance"><a href="/page4"><span>Bulk Transcriptomics of Myometrium (proliferative)</span></a></h2> 
       <h2 class="frontpage-entrance"><a href="/page5"><span>Bulk Transcriptomics of Endometrium (WOI)</span></a></h2> 
       <h2 class="frontpage-entrance"><a href="/page6"><span>Bulk Transcriptomics of Stromal Cell (secretory)</span></a></h2> 
       <h2 class="frontpage-entrance"><a href="/page7"><span>Bulk Transcriptomics of Epithelial Organoids (secretory)</span></a></h2>
       <h2 class="frontpage-entrance"><a href="/page8"><span>Bulk Transcriptomics of Epithelial Organoids (gestational)</span></a></h2>
      </div>
    </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ImageGrid',
    data() {
      return {
        hovered: false,
        // images: [
        //   { src: require("../assets/function1.png"), link: '/page1' },
        //   { src: require("../assets/function2.png"), link: '/page2' },
        //   { src: require("../assets/function3.png"), link: '/page3' },
        //   { src: require("../assets/function4.png"), link: '/page4' }
        // ]
      };
    }
  }
  </script>
  
  <style scoped>

  /* .image-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 0 10%;
    margin-top: 20px;
  } */
  .frontpage-h1{
    font-size: 36px;
    text-align: center;
  }

  .article-title{
    display: grid;
  place-items: center; 
  }

  .article-name{
    font-size: 30px;
    text-align: center;
    font-style: italic;
    max-width: 1200px;
  }

  .article-name:hover{
    color:#0099cc;
  }

  a {
  text-decoration: none; /* Remove underline */
  color: inherit; /* Use the color inherited from the parent */
}

  .frontpage-container{
    display: grid;
    grid-template-columns: 30% 70%;
    width:75%;
    margin:auto;
  }

  .right{
    text-align: center;
  }

  .frontpage-entrance{
    font-size: 20px;
    margin-top: 25px;
  }

  .frontpage-entrance:hover{
    color:#0099cc;
  }

  .image-link {
    text-decoration: none;
    color: inherit;
  }
  
  .image {
    /* border: 1px solid #ccc; */
    /* padding: 10px; */
    max-width: 100%;
    height: auto;
    position: relative;
  }

  .image_front {
    /* border: 1px solid #ccc; */
    /* padding: 10px; */
    max-width: 120%;
    height: auto;
    position: relative;
  }
  
  .hover-text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s;
  }
  
  .image:hover .hover-text {
    opacity: 1;
  }

  /* body{
  background: #e9f0f4;
} */
  </style>
  